module.exports = __webpack_public_path__ + "img/tianshi.c3fd31dc.png";